const defaultHeaders = new Headers();

const fetchOptions = (method = "GET", body = null) => {
  const options = {
    method,
    headers: defaultHeaders,
    credentials: "include",
    redirect: "follow",
  };
  if (body) {
    options.body = body;
  }
  return options;
};

export const getSubproductosByEmpresa = async (baseUrl, empresa) => {
  const response = await fetch(
    `${baseUrl}getSubproductosByEmpresa?empresa=${empresa}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(`Error al obtener los tipos de subproducto (${response.status})`);
  }
  const data = await response.json();
  if (Array.isArray(data.subproductos)) return data.subproductos;
  throw new Error("Formato de respuesta inesperado");
};

export const createSubproducto = async (baseUrl, { empresa, descripcion, unidad, idUsuario, incluido }, headers) => {
  const queryParams = new URLSearchParams({
    empresa,
    descripcion,
    unidad,
    idUsuario,
    incluido: Boolean(incluido)
  });

  const response = await fetch(`${baseUrl}createSubproducto?${queryParams.toString()}`, {
    method: "POST",
    headers,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.mensaje || "Error al crear subproducto");
  }

  return data;
};

export const updateTipoSubproducto = async (baseUrl, subproducto, headers) => {
  const response = await fetch(`${baseUrl}updateTipoSubproducto`, {
    method: "PUT",
    headers,
    body: JSON.stringify(subproducto),
  });
  if (!response.ok) {
    throw new Error("Error saving the subproducto");
  }
  return await response.json();
};

export const insertTarifaSubproducto = async (
  baseUrl,
  { idTipoSubproducto, idEmpresa, tarifaBase, idUsuario, moneda }
) => {
  const queryParams = new URLSearchParams({
    idTipoSubproducto,
    idEmpresa,
    tarifaBase,
    idUsuario,
    moneda
  });

  const response = await fetch(`${baseUrl}insertTarifaSubproducto?${queryParams.toString()}`, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    credentials: "include",
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.mensaje || "Error al crear subproducto");
  }

  return data;
};

export const createSubproductoFicha = async (baseUrl, { idSubproducto, perfil, ficha }) => {
  const response = await fetch(`${baseUrl}/createSubproductoFicha`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify({ idSubproducto, perfil, ficha }),
  });
  if (!response.ok) {
    throw new Error("Error al crear la ficha técnica");
  }
  return true;
};

export const updateTipoSubproductoFicha = async (baseUrl, { idSubproducto, perfil, ficha }) => {
  const response = await fetch(`${baseUrl}updateTipoSubproductoFicha`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json; charset=UTF-8",
    },
    body: JSON.stringify({ idSubproducto, perfil, ficha }),
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error("Error al actualizar la ficha del subproducto");
  }
  return true;
};
